module.exports = __webpack_public_path__ + "static/media/scan-white.abed8881.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/scan-white.png
// module id = 1060
// module chunks = 1